export const BASE_URL = "https://doccords-api.herokuapp.com/api/v1";
export const HEALTH_TOPIC_URL = BASE_URL + "/healthTopics";
export const ARTICLES_URL = BASE_URL + "/articles";
